import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FormInputError from "./FormInputError"

interface InputFieldProps {
    className?: string;
    label?: string;
    required?: boolean;
    requiredColor?: string;
    initialValue?: string;
    placeholder?: string;
    disabled?: boolean;
    paddingX?: string;
    paddingY?: string;
    onValueChange?: (value: string) => void;
    children?: React.ReactNode;
    errorMessage?: string;
    [key: string]: any;
}

const propTypes = {
    label: PropTypes.string,
    initialValue: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    paddingX: PropTypes.string,
    paddingY: PropTypes.string,
    onValueChange: PropTypes.func, // Use onValueChange instead of onChange
    errorMessage: PropTypes.string
}

const defaultProps = {
    label: '',
    initialValue: '',
    placeholder: '',
    disabled: false,
    paddingY: '10px',
    paddingX: '15px',
    onValueChange: () => {},
    errorMessage: null
}

const InputField = ({
    className,
    label,
    required,
    requiredColor,
    initialValue,
    placeholder,
    disabled,
    paddingX,
    paddingY,
    onValueChange, // Use onValueChange to receive updated value
    children,
    errorMessage,
    ...props
}: InputFieldProps) => {
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue); // Update the state when initialValue changes
    }, [initialValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
        onValueChange?.(event.target.value) // Call onValueChange with updated value
    }

    const classes = classNames(className, children ? 'input-container' : undefined)
    const inputClasses = classNames('w-100 mt-2', errorMessage?  'mb-1' : 'mb-2')

    return (
        <>
            <div className={classes}>
                <div>
                    <div className="d-flex font-xs font-bold">{label}{required && <span className={`${requiredColor || 'text-danger'} ms-1`}>*</span>}</div>
                    <input
                        className={inputClasses}
                        style={{height: '45px'}}
                        onChange={handleChange}
                        disabled={disabled}
                        value={value} // Use value from state
                        placeholder={placeholder}
                        {...props}
                    />
                </div>
                <div className="input-trailing">{children}</div>

                {
                    errorMessage &&
                    <FormInputError>{errorMessage}</FormInputError>
                }
            </div>
        </>
    )
}

InputField.propTypes = propTypes
InputField.defaultProps = defaultProps

export default InputField
